import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    // Stack title above actions on mobile so neither has to truncate; switch
    // to the original row layout from sm+. Most page headers ship a primary
    // CTA in `actions` — keeping it full-width on phones makes it the
    // obvious tap target.
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-6 pb-5 sm:pb-6 border-b border-white/5 mb-5 sm:mb-6">
      <div className="min-w-0">
        <h1 className="text-xl sm:text-[22px] font-semibold text-slate-100 leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-slate-500 mt-1.5">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 sm:shrink-0 [&>.btn-primary]:w-full sm:[&>.btn-primary]:w-auto">
          {actions}
        </div>
      )}
    </div>
  );
}
